//  Forked from @material-ui/core@4.11.0 @material-ui/styles@4.10.0
//  The reason is when using multiple/nested theme providers, the counter which is in charge to
//  force uniqueness of class names, has multiple instances in memory, which breaks uniqueness
//  when overriding classes. We replaced that with uuid-4 generator ("getNextHash")

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');
var isProduction = require('../helpers').isProduction;

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.default = createGenerateClassName_fork;

// var _nested = _interopRequireDefault(require('../ThemeProvider/nested'));
var _nested = _interopRequireDefault(require('./nested_fork'));

/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */
var pseudoClasses = [
  'checked',
  'disabled',
  'error',
  'focused',
  'focusVisible',
  'required',
  'expanded',
  'selected'
]; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js

function createGenerateClassName_fork() {
  var options =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal,
    disableGlobal =
      _options$disableGloba === void 0 ? false : _options$disableGloba,
    _options$productionPr = options.productionPrefix,
    productionPrefix =
      _options$productionPr === void 0 ? 'jss' : _options$productionPr,
    _options$seed = options.seed,
    seed = _options$seed === void 0 ? '' : _options$seed;
  var seedPrefix = seed === '' ? '' : ''.concat(seed, '-');

  var getNextHash = function getNextHash() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      // eslint-disable-next-line no-mixed-operators
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  };

  return function(rule, styleSheet) {
    var name = styleSheet.options.name; // Is a global static MUI style?

    if (
      name &&
      name.indexOf('Mui') === 0 &&
      !styleSheet.options.link &&
      !disableGlobal
    ) {
      // We can use a shorthand class name, we never use the keys to style the components.
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return 'Mui-'.concat(rule.key);
      }

      var prefix = ''
        .concat(seedPrefix)
        .concat(name, '-')
        .concat(rule.key);

      if (!styleSheet.options.theme[_nested.default] || seed !== '') {
        return prefix;
      }

      return ''.concat(prefix, '-').concat(getNextHash());
    }

    if (isProduction) {
      return ''
        .concat(seedPrefix)
        .concat(productionPrefix)
        .concat(getNextHash());
    }

    var suffix = ''.concat(rule.key, '-').concat(getNextHash()); // Help with debuggability.

    if (styleSheet.options.classNamePrefix) {
      return ''
        .concat(seedPrefix)
        .concat(styleSheet.options.classNamePrefix, '-')
        .concat(suffix);
    }

    return ''.concat(seedPrefix).concat(suffix);
  };
}
